export default __webpack_public_path__ + "KaTeX_Size3-Regular.5d632274432b02a0edebbfe5810cc988.ttf";